import time from "@/utils/helpers/timer";
import keyval from "@/utils/dickeyval";
import { getStorage } from '@/utils/helpers/storage'
export default {
  numberFormat(val) {
    if (!val) return "0";
    val = Number(val)
      .toFixed(2)
      .replace(/^(\d*).(\d*)/, (...args) =>
        args[1].replace(/\B(?=(?:\d{3})+$)/g, ",")
      );
    return val;
  },
  amtFormat(val,tip) {
    let value = "";
    if (!val) {
      return "0.00";
    }
    if (val === 0 || val) {
      value = tip? val : val / 100
      return Number(value).toFixed(2);
    }
  },

  oninput (val, limit = 0) {
    // val = val.replace(/[^\d.]/g, ""); //保留数字
    val = val.replace(/[^\d.]/g, ""); //保留数字
    val = val.replace(/^00/, "0."); //开头不能有两个0
    val = val.replace(/^\./g, "0."); //开头为小数点转换为0.
    val = val.replace(/\.{2,}/g, "."); //两个以上的小数点转换成一个
    val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留一个小数点
    /^0\d+/.test(val) ? (val = val.slice(1)) : ""; //两位以上数字开头不能为0
    const str = "^(\\d+)\\.(\\d{" + limit + "}).*$";
    const reg = new RegExp(str);
    if (limit === 0) {
      // 不需要小数点
      val = val.replace(reg, "$1");
    } else {
      // 通过正则保留小数点后指定的位数
      val = val.replace(reg, "$1.$2");
    }
    return val;
  },
  kgFormat(val) {
    let value = "";
    if (val === 0 || val) {
      value = val / 1000;
      return Number(value).toFixed(3);
    }
  },
  getDate(val) {
    if (val) {
      return time.getDate(val);
    } else {
      return "-";
    }
  },
  getTime(val) {
    if (val) {
      return time.getTime(val);
    } else {
      return "-";
    }
  },
  getDateTime(val) {
    if (val) {
      return time.getDateTime(val);
    } else {
      return "-";
    }
  },
  getYearMouth(val) {
    if (val) {
      return time.getYearMouth(val);
    } else {
      return "-";
    }
  },
  // 本地字典
  getValText (key, val) {
    if (val === null || val === undefined) return '--'
    let list = keyval[key]
    for (let i = 0; i < list.length; i++) {
      let item = list[i]
      if (item.hasOwnProperty('val')) {
        if (item.val == val) {
          return item.text || item.name
        }
      } else if (item.hasOwnProperty('id')) {
        if (item.id == val) {
          return item.text || item.name
        }
      }
    }
    // return val || '--'
    return '未知'
  },
  // 获取数据库字典数据
  getDictText (key, val) {
    let sysDict = getStorage('sysDict')
    if(val === null || val === undefined) return '--'
    let list = sysDict[key]
    for (let i = 0; i < list.length; i++) {
      let item = list[i];
      if (item.hasOwnProperty('val')) {
        if (item.val == val) {
          return item.text || item.name
        }
      } else if (item.hasOwnProperty('id')) {
        if (item.id == val) {
          return item.text || item.name
        }
      }
    }
    return val || "--";
  },
  getDictList (key) {
    let sysDict = getStorage('sysDict')
    let list = sysDict[key]
    if (list && list.length) {
      return list
    } else {
      return []
    }
  },
  discountFormat(val) {
    val = !val ? "100" : val;
    return calculation.accDiv(val, 10);
  },
  cardDiscount(value, type) {
    if (type === 2) {
      return "多折扣";
    }
    return value && value < 100
      ? calculation.accDiv(value, 10) + "折"
      : "不打折";
  },
};
